import React, { useContext } from 'react';
import { Switch, Route } from 'react-router-dom';
import { AuthContext } from 'shared/context/auth-context';
import HomePage from 'containers/HomePage/HomePage';
import SearchInsuranceContracts from 'containers/Choices/InsuranceContracts/SearchInsuranceContracts';
import UploadFile from 'containers/Choices/UploadContract/UploadFile';
import UploadExcelEmissions from 'containers/Choices/UploadContract/UploadExcelEmissions';
import UploadDevicesForReset from 'containers/Choices/UploadDevicesForReset/UploadDevicesForReset';
import SearchPackingList from 'containers/Choices/PackingList/SearchPackingList/SearchPackingListObd';
import SearchPackingListBl from 'containers/Choices/PackingList/SearchPackingList/SearchPackingListBl';
import SearchSms from 'containers/Statistics/Sms/SearchSms';
import SearchReportStatus from 'containers/Statistics/ReportStatus/SearchReportStatus';
import SearchPermissions from 'containers/Statistics/BeaconDiagnostics/SearchPermissions';
import SearchHeartbeat from 'containers/Statistics/BeaconDiagnostics/SearchHeartbeat';
import SearchAlarms from 'containers/Statistics/Alarms/SearchAlarms';
import InsuranceContracts from 'containers/Choices/InsuranceContracts/InsuranceContracts';
import DetailsOfInsuranceContract from 'containers/Choices/InsuranceContracts/DetailsOfInsuranceContract';
import PackingListResults from 'containers/Choices/PackingList/PackingListResults';
import NewDevice from 'containers/Choices/PackingList/NewDevice';
import SearchReportTrips from 'containers/Statistics/ReportTrips/SearchReportTrips';
import InstallationGuide from 'containers/Choices/InstallationGuide/InstallationGuide';
import { PackageContextProvider } from 'containers/Choices/PackingList/Package/package-context';
import DeviceOverview from 'containers/Choices/PackingList/DeviceOverview/DeviceOverview';
import DeviceSettings from 'containers/Choices/PackingList/DeviceSettings';
import SearchVehicle from 'containers/Statistics/Vehicles/SearchVehicles';
import SearchDeviceContract from 'containers/Choices/PackingList/DeviceTracking/SearchDeviceContract';
import UpdateParcelDecider from 'containers/Choices/PackingList/Package/UpdateParcel/UpdateParcelDecider';
import PackageDecider from 'containers/Choices/PackingList/Package/PackageDecider';
import SearchNoLogin from 'containers/Statistics/NoLogin/SearchNoLogin';
import Message from 'containers/Choices/Message/Message';
import NoPaired from 'containers/Statistics/NoPaired/NoPaired';
import SearchDeviceStatus from 'containers/Statistics/DeviceStatus/SearchDeviceStatus';
import SearchEmissions from 'containers/Statistics/Emmisions/SearchEmissions';
import DeleteKilometers from 'containers/Choices/DeleteKilometers/DeleteKilometers';

export default function Routes() {
  const { roleUser } = useContext(AuthContext);
  const allRoles = ['AnyTimeAdmin', 'AnyTime', 'GT'];

  const routes = [
    {
      id: 1,
      path: '/',
      exact: true,
      component: <HomePage />,
      role: allRoles
    },
    {
      id: 2,
      path: '/choices/search-insurance-contracts',
      exact: true,
      component: <SearchInsuranceContracts />,
      role: allRoles,
      title: 'Ασφαλιστήρια Συμβόλαια'
    },
    {
      id: 3,
      exact: true,
      path: '/choices/packing-list/packingObd',
      component: <SearchPackingList />,
      role: ['GT'],
      title: 'Packing List'
    },
    {
      id: 4,
      path: '/choices/file-import',
      exact: false,
      component: <UploadFile />,
      role: ['GT']
    },
    {
      id: 5,
      path: '/statistics/customer-reports/status',
      exact: false,
      component: <SearchReportStatus />,
      role: ['GT']
    },
    {
      id: 6,
      path: '/statistics/customer-reports/sms',
      exact: false,
      component: <SearchSms />,
      role: ['GT']
    },
    {
      id: 7,
      path: '/statistics/customer-reports/trips',
      exact: false,
      component: <SearchReportTrips />,
      role: ['GT']
    },
    {
      id: 8,
      path: '/statistics/customer-reports/alarms',
      exact: false,
      component: <SearchAlarms />,
      role: ['GT']
    },
    {
      id: 9,
      path: '/choices/insurance-contracts',
      exact: true,
      component: <InsuranceContracts />,
      role: allRoles
    },
    {
      id: 10,
      path: '/choices/insurance-contracts/:id',
      exact: true,
      component: <DetailsOfInsuranceContract />,
      role: allRoles
    },
    {
      id: 11,
      path: '/choices/packing-list/packing-list-result',
      exact: true,
      component: <PackingListResults />,
      role: ['GT']
    },
    {
      id: 12,
      path: ['/choices/new-packageObd', '/choices/new-packageBl'],
      exact: true,
      component: (
        <PackageContextProvider>
          {' '}
          <PackageDecider />
        </PackageContextProvider>
      ),
      role: ['GT']
    },
    {
      id: 13,
      path: '/choices/new-device',
      exact: true,
      component: (
        <PackageContextProvider>
          {' '}
          <NewDevice />
        </PackageContextProvider>
      ),
      role: ['GT']
    },
    {
      id: 14,
      path: '/choices/installation-guide',
      exact: true,
      component: <InstallationGuide />,
      role: allRoles
    },
    {
      id: 15,
      exact: true,
      path: '/choices/packing-list/device-overview',
      component: <DeviceOverview />,
      role: ['GT'],
      title: 'DeviceOverview'
    },
    {
      id: 16,
      path: '/choices/device-settings/:deviceImei',
      exact: true,
      component: <DeviceSettings />,
      role: ['GT']
    },
    {
      id: 17,
      path: '/statistics/customer-reports/vehicles',
      exact: false,
      component: <SearchVehicle />,
      role: ['GT']
    },
    {
      id: 18,
      path: '/choices/packing-list/device-status-tracking',
      exact: true,
      component: <SearchDeviceContract />,
      role: ['GT']
    },
    {
      id: 19,
      path: '/choices/packing-list/device-trips-tracking',
      exact: true,
      component: <SearchDeviceContract />,
      role: ['GT']
    },
    {
      id: 20,
      path: '/choices/packing/updatePacking',
      exact: true,
      component: (
        <PackageContextProvider>
          {' '}
          <UpdateParcelDecider />
        </PackageContextProvider>
      ),
      role: ['GT']
    },
    {
      id: 21,
      exact: true,
      path: '/choices/packing-list/packingBl',
      component: <SearchPackingListBl />,
      role: ['GT'],
      title: 'Packing List Bluetooth'
    },
    {
      id: 22,
      path: '/choices/message',
      exact: false,
      component: <Message />,
      role: ['GT']
    },
    {
      id: 23,
      path: '/statistics/customer-reports/permissions',
      exact: false,
      component: <SearchPermissions />,
      role: ['GT']
    },
    {
      id: 24,
      path: '/statistics/customer-reports/heartbeat',
      exact: false,
      component: <SearchHeartbeat />,
      role: ['GT']
    },
    {
      id: 25,
      path: '/statistics/customer-reports/nologin',
      exact: true,
      component: <SearchNoLogin />,
      role: ['GT']
    },
    {
      id: 26,
      path: '/statistics/customer-reports/nopaired',
      exact: true,
      component: <NoPaired />,
      role: ['GT']
    },
    {
      id: 21,
      exact: true,
      path: '/choices/configDevice',
      component: <SearchPackingListBl isDeviceConfiguration />,
      role: ['GT'],
      title: 'Config Device'
    },
    {
      id: 27,
      path: '/statistics/customer-reports/deviceStatus',
      exact: true,
      component: <SearchDeviceStatus />,
      role: ['GT']
    },
    {
      id: 28,
      path: '/choices/upload-excel-emissions',
      exact: true,
      component: <UploadExcelEmissions />,
      role: ['GT']
    },
    {
      id: 29,
      path: '/statistics/customer-reports/emissions',
      exact: true,
      component: <SearchEmissions />,
      role: ['GT']
    },
    {
      id: 30,
      path: '/choices/delete-kilometers',
      exact: true,
      component: <DeleteKilometers />,
      role: ['GT']
    },
    {
      id: 31,
      path: '/choices/upload-excel-device-reset',
      exact: true,
      component: <UploadDevicesForReset />,
      role: ['GT']
    }
  ];

  const getAllowedRoutes = routes.filter(
    route => route.role.indexOf(roleUser) !== -1
  );
  const routeComponents = getAllowedRoutes.map(
    ({ path, component, exact, id }) => (
      <Route key={id} exact={exact} path={path}>
        {component}
      </Route>
    )
  );
  const subRoutesComponents = getAllowedRoutes.map(({ subroutes }) =>
    subroutes?.map(({ path, component, exact, id }) => (
      <Route key={id} exact={exact} path={path}>
        {component}
      </Route>
    ))
  );
  return (
    <Switch>
      {subRoutesComponents}
      {routeComponents}
    </Switch>
  );
}
